<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="ips"
          no-data-text="No Ips Associated to your Login"
        >
          <template v-slot:top>
            <v-toolbar flat>
              
              <v-spacer></v-spacer>
              <add-ip-form>
                <v-btn color="primary">Add Ip</v-btn>
              </add-ip-form>
            </v-toolbar>
          </template>
          <template v-slot:item.deleteAfterDate="{ item }">
            <span>{{ new Date(item.deleteAfterDate).toLocaleString() }}</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <confirm-delete-ip :ip="item" class="float-left">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="red" v-bind="attrs" v-on="on">
                    mdi-delete
                  </v-icon>
                </template>
                <span>Delete {{ item.ipAddress }}</span>
              </v-tooltip>
            </confirm-delete-ip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import AddIpForm from './AddIpForm.vue';
import ConfirmDeleteIp from './ConfirmDeleteIp.vue';
const { mapState, mapActions } = createNamespacedHelpers('atlasadmin');
export default {
  components: { AddIpForm, ConfirmDeleteIp },
  name: 'IpList',
  async created() {
    await this.getIps();
  },
  methods: {
    ...mapActions(['getIps']),
    editItem(item) {
      console.log(item);
      alert('Not yet implemented');
    }
  },
  computed: {
    ...mapState(['ips'])
  },
  data() {
    return {
      headers: [
        {
          text: 'Comment',
          value: 'comment',
          sortable: true
        },
        {
          text: 'Ip Address',
          value: 'ipAddress',
          sortable: true
        },
        {
          text: 'Expires On',
          value: 'deleteAfterDate',
          sortable: true
        },
        {
          text: 'Action',
          value: 'actions',
          sortable: false,
          align: 'end'
        }
      ]
    };
  }
};
</script>

<style></style>
